export default __webpack_public_path__ + "static/CURIO-e3696bd882dc6b5713493473bcfa68bf.svg";